export enum CaseListFolderType{
    AllActive, 
    OnHold,
    PreLegal,
    Reminder,
    Legal,
    Surveillance,
    LastClosed
}